import { Anchor, Table, Badge, Text, Card, Group, Stack } from '@mantine/core'
import { jobApplicationStatusColor } from '../lib/jobApplicationStatusColors'

// #1126 admin 応募一覧のテーブル。行データは Rails 側で組み立てて props で受け取り、ここでは描画のみ。
// ステータスは Badge(status_i18n のラベル)で表示する。色は lib/jobApplicationStatusColors(JobApplicationList・応募詳細と共有)。
// #1234 sm 未満はテーブルではなくカードのスタック表示にする(横スクロール前提の表をモバイルに出さない)。

function AdminJobApplicationRowCard({ row }) {
  const applicant = row.applicantName
    ? (row.href ? <Anchor href={row.href}>{row.applicantName}</Anchor> : row.applicantName)
    : <Text c="dimmed" span>(退会ユーザー)</Text>

  const card = (
    <Card withBorder radius="md" padding="md">
      <Group justify="space-between" align="flex-start" wrap="nowrap" mb={4}>
        <Text fw={500} lineClamp={2} style={{ flex: 1 }}>{row.positionTitle}</Text>
        <Badge color={jobApplicationStatusColor(row.status)} variant="light" radius="sm">
          {row.statusLabel}
        </Badge>
      </Group>
      <Text size="sm" mb={2}>{applicant}</Text>
      <Text size="sm" c="dimmed" lineClamp={1} mb="xs">{row.companyName}</Text>
      <Group justify="space-between" gap="xs">
        <Text size="xs" c="dimmed">応募日 {row.appliedAt}</Text>
        <Text size="xs" c="dimmed">最終更新 {row.updatedAt}</Text>
      </Group>
    </Card>
  )

  if (!row.href) return card
  return <Anchor component="a" href={row.href} underline="never" c="inherit">{card}</Anchor>
}

export default function AdminJobApplicationTable({ rows = [] }) {
  if (rows.length === 0) {
    return <Text c="dimmed" py="xl" ta="center">該当する応募はありません。</Text>
  }

  return (
    <>
      <Table.ScrollContainer minWidth={760} visibleFrom="sm">
        <Table striped highlightOnHover withTableBorder verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th w={110}>応募日</Table.Th>
              <Table.Th>応募者</Table.Th>
              <Table.Th>案件</Table.Th>
              <Table.Th>企業</Table.Th>
              <Table.Th w={110}>ステータス</Table.Th>
              <Table.Th w={150}>最終更新</Table.Th>
              <Table.Th w={70}></Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((row) => (
              <Table.Tr key={row.id}>
                <Table.Td>{row.appliedAt}</Table.Td>
                {/* #1127 応募者名と行末の「詳細」から応募詳細(/admin/applications/:id)へ */}
                <Table.Td>
                  {row.applicantName
                    ? (row.href ? <Anchor href={row.href} fz="sm">{row.applicantName}</Anchor> : row.applicantName)
                    : <Text c="dimmed" span>(退会ユーザー)</Text>}
                </Table.Td>
                <Table.Td>{row.positionTitle}</Table.Td>
                <Table.Td>{row.companyName}</Table.Td>
                <Table.Td>
                  <Badge color={jobApplicationStatusColor(row.status)} variant="light" radius="sm">
                    {row.statusLabel}
                  </Badge>
                </Table.Td>
                <Table.Td>
                  <Text fz="sm" c="dimmed">{row.updatedAt}</Text>
                </Table.Td>
                <Table.Td>
                  {row.href && <Anchor href={row.href} fz="sm">詳細</Anchor>}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>

      <Stack gap="sm" hiddenFrom="sm">
        {rows.map((row) => (
          <AdminJobApplicationRowCard key={row.id} row={row} />
        ))}
      </Stack>
    </>
  )
}
